import { useState, useEffect } from 'react';
import { API_URLS } from '../../apiUrl';
import { Pagination } from '@mui/material';
import PropertyDescriptionEdit from '../../editModals/propertyDescriptionEdit';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../components/axiosInstance';

const PropertyDescriptionList = () => {
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);

  const [inputData, setInputData] = useState({ page: 1, limit: 50 });
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(50);

  const [propertyDescription, setPropertyDescription] = useState<any>("");
  const [propertyDescriptionId, setPropertyDescriptionId] = useState<any>("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.post(`${API_URLS.PropertyDescriptionList}`, {
          page: inputData.page,
          limit: inputData.limit
        });

        if (response.data && response.data.data) {
          setTableData(response.data.data.data);
          setTotalItems(response.data.data.total);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [inputData.page]);

  const filteredData = tableData.filter((item: any) => {
    const statusLabel = item.status === 1 ? 'active' : item.status === 2 ? 'inactive' : '';
  
    return (
      item.description_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.property_type_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.purposeOfUse_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.property_type_descriptions?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.use_of_property_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      statusLabel.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const handlePageChange = (event: any, value: number) => {
    setInputData((prevData) => ({
      ...prevData,
      page: value,
    }));
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [propertyTypeId, setPropertyTypeId] = useState<any>("");
  const [propertyTypeDescriptionId, setPropertyTypeDescriptionId] = useState<any>("");
  const [useOfPropertyId, setUseOfPropertyId] = useState<any>("");
  const [purposeOfUseId, setPurposeOfUseId] = useState<any>("");
  const [propertyTypeName, setPropertyTypeName] = useState<any>("");
  const [propertyTypeDescriptionName, setPropertyTypeDescriptionName] = useState<any>("");
  const [useOfPropertyName, setUseOfPropertyName] = useState<any>("");
  const [purposeOfPropertyName, setPurposeOfPropertyName] = useState<any>("");

  const openModal = (propertyDescription: any, propertyDescriptionId: any, propertyTypeId: any, propertyTypeDescriptionId: any, useOfPropertyId: any, purposeOfUseId: any, propertyTypeName: any, propertyTypeDescriptionName: any, useOfPropertyName: any, purposeOfPropertyName: any) => {
    setPropertyDescription(propertyDescription);
    setPropertyDescriptionId(propertyDescriptionId);
    setPropertyTypeId(propertyTypeId);
    setPropertyTypeDescriptionId(propertyTypeDescriptionId);
    setUseOfPropertyId(useOfPropertyId);
    setPurposeOfUseId(purposeOfUseId);
    setPropertyTypeName(propertyTypeName);
    setPropertyTypeDescriptionName(propertyTypeDescriptionName);
    setUseOfPropertyName(useOfPropertyName);
    setPurposeOfPropertyName(purposeOfPropertyName);

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [animatingItems, setAnimatingItems] = useState<{ [key: number]: boolean }>({});

  const handleStatusToggle = async (id: any, currentStatus: any) => {
    setAnimatingItems((prev) => ({ ...prev, [id]: true }));

    const newStatus = currentStatus === 1 ? 2 : 1;

    setTableData((prevData: any) =>
      prevData.map((item: any) =>
          item.des_id_primary === id ? { ...item, status: newStatus } : item
      )
    );

    try {
      const response = await axiosInstance.put(`${API_URLS.PropertydescriptionStatus}`, {
        status: newStatus,
        property_description_id: id
      });

      if (response.data.message == "Property description updated successfully") {
        toast.success('Status updated successfully!');
      } else {
        toast.error('Failed to update status.');
      }
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setTimeout(() => {
        setAnimatingItems((prev) => ({ ...prev, [id]: false }));
      }, 300);
    }
  };

  return (
    <div className="container mx-auto">
      <ToastContainer />
      <div className="flex gap-5 mb-4">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Property Description List</h1>

        <div className="flex justify-end md:w-4/12 w-full ml-auto">
          <input
            type="text"
            placeholder="Search..."
            className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
        <table className="min-w-full table-auto">
          <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
            <tr>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Property Type</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Propert Type Description</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Use Of Property</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Purpose Of Property</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Description Name</th>
              <th className="py-3 px-6 text-center text-sm font-medium text-gray-600 dark:text-gray-100">Status</th>
              <th className="py-3 px-6 text-center text-sm font-medium text-gray-600 dark:text-gray-100">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="py-3 px-6 text-center">Loading...</td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={7} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
              </tr>
            ) : (
              filteredData.map((item: any, index) => (
                <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.property_type_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.property_type_descriptions || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.use_of_property_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.purposeOfUse_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.description_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-center">
                    <button
                      onClick={() => handleStatusToggle(item.des_id_primary, item.status)}
                      className={`inline-block px-3 py-1 text-xs font-medium rounded-full border ${item.status === 1 ? 'text-green-500 border-green-200 bg-green-100' : 'text-red-500 border-red-200 bg-red-100'} ${animatingItems[item.des_id_primary] ? 'status-change' : ''}`}
                    >
                      {item.status === 1 ? 'Active' : 'Inactive'}
                    </button>
                  </td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600 text-center">
                    <div className="flex gap-2">
                      <button onClick={() => openModal(item.description_name, item.des_id_primary, item.property_type_id, item.property_type_description_id, item.use_of_property_id, item.purpose_of_use_id, item.property_type_name, item.property_type_descriptions,item.use_of_property_name,item.purposeOfUse_name)}
                        className="px-2 py-1.5 text-green-500 border border-green-200 rounded bg-green-100 hover:bg-green-200"
                      >
                        <i className="ri-edit-line"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {filteredData?.length === 0 ? null :
        <div className="flex justify-center mt-4">
          <Pagination
            count={totalPages}
            page={inputData.page}
            onChange={handlePageChange}
            color="primary"
          />
        </div>}

      <PropertyDescriptionEdit isOpen={isModalOpen} closeModal={closeModal} propertyDescriptionId={propertyDescriptionId} propertyDescription={propertyDescription} propertyTypeId={propertyTypeId} propertyTypeDescriptionId={propertyTypeDescriptionId} useOfPropertyId={useOfPropertyId} purposeOfUseId={purposeOfUseId} propertyTypeName={propertyTypeName} propertyTypeDescriptionName={propertyTypeDescriptionName} useOfPropertyName={useOfPropertyName} purposeOfPropertyName={purposeOfPropertyName}  />
    </div>
  );
};

export default PropertyDescriptionList;